export default __webpack_public_path__ + "static/media/FM.2b87cef3.svg";